// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let V4 = require("uuid/v4");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelay__Showings__Showing = require("./PropertyWizardRelay__Showings__Showing.bs.js");
let PropertyWizardRelayShowings_draft_graphql = require("../../../__generated__/PropertyWizardRelayShowings_draft_graphql.bs.js");
let PropertyWizardRelayShowings_showing_graphql = require("../../../__generated__/PropertyWizardRelayShowings_showing_graphql.bs.js");

function PropertyWizardRelay__Showings$ScheduleShowing(props) {
  return JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    onClick: props.onClick,
    children: props.text
  });
}

let ScheduleShowing = {
  make: PropertyWizardRelay__Showings$ScheduleShowing
};

let convertFragment = PropertyWizardRelayShowings_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, PropertyWizardRelayShowings_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
}

let ShowingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayShowings_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Showings(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowings_draft_graphql.node, convertFragment$1, props.draft);
  let fRef = draft.draftProperty.showings.map(s => s.fragmentRefs);
  let showings = RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowings_showing_graphql.node, convertFragment, fRef);
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let addNewShowing = param => updateDraftProperty(localDraftProperty => {
    let newrecord = {...localDraftProperty};
    newrecord.showings = localDraftProperty.showings.concat([{
        date: undefined,
        endTime: undefined,
        id: undefined,
        key: V4(),
        notes: undefined,
        startTime: undefined,
        type_: undefined
      }]);
    return newrecord;
  });
  let _more = showings.length;
  return JsxRuntime.jsxs(FormV5.FormSection.make, {
    children: [
      showings.map((s, index) => JsxRuntime.jsx(View__Jsx3.make, {
        mt: "xl",
        children: JsxRuntime.jsx(PropertyWizardRelay__Showings__Showing.make, {
          showing: s.fragmentRefs,
          draft: draft.fragmentRefs,
          showingNum: index
        })
      }, s.key)),
      _more !== 0 ? JsxRuntime.jsx(View__Jsx3.make, {
          mt: "md",
          justifyContent: "flexEnd",
          children: JsxRuntime.jsx(PropertyWizardRelay__Showings$ScheduleShowing, {
            onClick: addNewShowing,
            text: "Schedule another showing"
          })
        }) : JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "You haven't added any showings for this property.",
              className: "pb-2"
            }),
            JsxRuntime.jsx(PropertyWizardRelay__Showings$ScheduleShowing, {
              onClick: addNewShowing,
              text: "Add a showing"
            })
          ],
          className: "text-center py-4"
        })
    ]
  });
}

let Components;

let FormSection;

let Validators;

let FormUtils;

let Form;

let Cell;

let Showing;

let make = PropertyWizardRelay__Showings;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Form = Form;
exports.Cell = Cell;
exports.Showing = Showing;
exports.ScheduleShowing = ScheduleShowing;
exports.ShowingsFragment = ShowingsFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
